<div class="row">
  <div class="fulfillmentLanding create-return-outer" (window:resize)="onresize($event)">
    <div class="create-return-page">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" routerLink="/seed-returns-soybean-dashboard">Soybean Dump</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor">
              <span id="spnBreadcrum">{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="returnTop">
        <!--Ship to - Confirmation Email Section-->
        <div *ngIf="isApprovalAccess">
          <div class="row">
            <div class=" col-lg-3 col-md-6 material-select withBordr">
              <ng-select name="ddlShipTo"
                         [items]="shipToAccountItems"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="isEditMode || reviewRequestMode"
                         bindValue="accountNumber"
                         placeholder="Account:"
                         [loading]="shipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getShipTo($event)"
                         (clear)="getShipTo($event)">
                <ng-template ng-label-tmp let-item="item" let-index="index">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                        <div class="mb-0 mt-2">
                          {{item.accountName}}
                        </div>
                        <div class="mb-0">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </div>
                        <div class="mb-0">
                          {{item.primaryPhoneNumber}}
                        </div>
                        <div>
                          Account #: {{item.accountNumber}}
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-lg-3 col-md-6">
              <mat-form-field class="wide100">
                <mat-label>SDM :</mat-label>
                <input [disabled]="isEditMode || reviewRequestMode" readonly matInput type=text name="dsm"
                       autocomplete="new-username"
                       [(ngModel)]="dsmInfo"
                       value="dsmInfo" />
              </mat-form-field>
            </div>
            <div class="col-lg-4 col-md-6" *ngIf="isShowNonSubEmail">
              <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
                <mat-label>Non-Subscriber Email:</mat-label>
                <input matInput type="email" name="accountEmail"
                       placeholder="(Separate multiple email addresses by a semi-colon)"
                       [(ngModel)]="accountEmail"
                       [readonly]="reviewRequestMode"
                       [pattern]="emailPattern"
                       (keyup)="validateEmail()"
                       (input)="hasEmailAddressChanged();"
                       email="true">
                <mat-error *ngIf="isNotValid">
                  This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div *ngIf="!isApprovalAccess">
          <div class="row">
            <div class=" col-md-6 material-select withBordr">
              <ng-select name="ddlShipTo"
                         [items]="shipToAccountItems"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="isEditMode || reviewRequestMode"
                         bindValue="accountNumber"
                         placeholder="Account:"
                         [loading]="shipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getShipTo($event)"
                         (clear)="getShipTo($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-3" *ngIf="isShowNonSubEmail">
              <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
                <mat-label>Non-Subscriber Email:</mat-label>
                <input matInput type="email" name="accountEmail"
                       placeholder="(Separate multiple email addresses by a semi-colon)"
                       [(ngModel)]="accountEmail"
                       [readonly]="reviewRequestMode"
                       [pattern]="emailPattern"
                       (keyup)="validateEmail()"
                       email="true">
                <mat-error *ngIf="isNotValid">
                  This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="returnDetail">
        <!--Product Detail section-->
        <div class="row" appClickOutside (clickOutside)="tabNode=''">
          <div class="col-md-12">
            <mat-tab-group disableRipple [animationDuration]="'0ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">
              <mat-tab>
                <ng-template mat-tab-label>
                  <div class="tab-head">
                    <h4>
                      Products
                    </h4>
                    <p>
                      Add / Manage Products for your return
                    </p>
                  </div>
                </ng-template>

                <div class="addProdContent">

                  <div class="grower-add-sec seed-return-filter">
                    <div *ngIf="!reviewRequestMode" class="row listing-action-items grower-page">
                      <div class="col-lg-8 col-md-9">
                        <mat-checkbox *ngIf="!reviewRequestMode && productAllDataSource?.filteredData?.length > 0" #AllProductCheck class="custom-checkbox select-all-check"
                                      [checked]="isAllProductChecked" id="chkSelectAll"
                                      [style.display]="disablecheckbox ? 'none' : 'block'"
                                      [indeterminate]="checkBoxCount > 0 && !isAllProductChecked"
                                      (change)="enableAllCheckBoxes(!isAllProductChecked)"
                                      title="Select All Lines"></mat-checkbox>
                        <div class="product-filter-outer">
                          <div class="product-filter col-md-12" *ngIf="!editToolKit || checkBoxCount<=0 || isSearchClicked">
                            <div class="search-category">
                              <div class="brand-dropdown default-select">
                                <ng-select [disabled]="reviewRequestMode" [items]="searchTypeList"
                                           name="ddlProductSearch"
                                           [(ngModel)]="productSearchFilter"
                                           [virtualScroll]="true"
                                           [closeOnSelect]="true"
                                           [selectOnTab]="true"
                                           [clearable]="false"
                                           bindLabel="name"
                                           bindValue="value"
                                           [searchable]="false"
                                           (change)="keepFilter()"
                                           placeholder="Select Category">
                                </ng-select>
                              </div>
                            </div>
                            <div class="search-box">
                              <div class="row margin-0">
                                <div class="default-select select-container">

                                  <div *ngIf="productSearchFilter === 'productName'">
                                    <div class="searchInputBox">
                                      <span class="search-icon">
                                        <i class="fas fa-search"></i>
                                      </span>
                                      <div class="select-container">
                                        <input (keyup.enter)="selectProductName($event)" [(ngModel)]="productFilters.productName" placeholder="Search">
                                      </div>
                                    </div>
                                  </div>

                                  <ng-select #marketingBrand name="ddlMarketingBrandSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                                             [items]="marketingBrandMasterList"
                                             placeholder="Search"
                                             class="custom-select-grower"
                                             [multiple]="true"
                                             [hideSelected]="true"
                                             [(ngModel)]="productFilters.marketingBrand"
                                             [virtualScroll]="true"
                                             bindLabel="value"
                                             bindValue="value"
                                             [closeOnSelect]="true"
                                             [searchFn]="filterSearchFn"
                                             (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                      <div class="dropdown-template">
                                        <div class="row">
                                          <div class="col-md-8">
                                            <p class="name">
                                              {{item.value}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                      <div class="ng-option disabled">
                                        No data found for "{{searchTerm}}"
                                      </div>
                                    </ng-template>
                                  </ng-select>

                                  <ng-select #packageSize name="ddlpackageSizeSearch" *ngIf="productSearchFilter === 'packageSize'"
                                             [items]="packageSizeMasterList"
                                             placeholder="Search"
                                             class="custom-select-grower"
                                             [multiple]="true"
                                             [hideSelected]="true"
                                             [(ngModel)]="productFilters.packageSize"
                                             [virtualScroll]="true"
                                             bindLabel="value"
                                             bindValue="value"
                                             [closeOnSelect]="true"
                                             [searchFn]="filterSearchFn"
                                             (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                      <div class="dropdown-template">
                                        <div class="row">
                                          <div class="col-md-8">
                                            <p class="name">
                                              {{item.value}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                      <div class="ng-option disabled">
                                        No data found for "{{searchTerm}}"
                                      </div>
                                    </ng-template>
                                  </ng-select>

                                  <div *ngIf="productSearchFilter === 'technology'">
                                    <div class="searchInputBox">
                                      <span class="search-icon">
                                        <i class="fas fa-search"></i>
                                      </span>
                                      <div class="select-container">
                                        <input (keyup.enter)="selectTechnology($event)" [(ngModel)]="productFilters.technology" placeholder="Search">
                                      </div>
                                    </div>
                                  </div>

                                  <ng-select #treatment name="ddlTreatmentSearch" *ngIf="productSearchFilter === 'treatmentDescription'"
                                             [items]="treatmentMasterList"
                                             placeholder="Search"
                                             class="custom-select-grower"
                                             [multiple]="true"
                                             [hideSelected]="true"
                                             [(ngModel)]="productFilters.treatmentDescription"
                                             [virtualScroll]="true"
                                             bindLabel="value"
                                             bindValue="value"
                                             [closeOnSelect]="true"
                                             [searchFn]="filterSearchFn"
                                             (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                      <div class="dropdown-template">
                                        <div class="row">
                                          <div class="col-md-8">
                                            <p class="name">
                                              {{item.value}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                      <div class="ng-option disabled">
                                        No data found for "{{searchTerm}}"
                                      </div>
                                    </ng-template>
                                  </ng-select>

                                  <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'itemNumber'"
                                             [items]="invoicedProductList"
                                             placeholder="Search"
                                             class="custom-select-grower"
                                             [multiple]="true"
                                             [hideSelected]="true"
                                             [(ngModel)]="productFilters.invoicedProductList"
                                             [virtualScroll]="true"
                                             bindLabel="value"
                                             bindValue="value"
                                             [closeOnSelect]="true"
                                             [searchFn]="filterSearchFn"
                                             (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                      <div class="dropdown-template">
                                        <div class="row">
                                          <div class="col-md-8">
                                            <p class="name">
                                              {{item.value}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                      <div class="ng-option disabled">
                                        No data found for "{{searchTerm}}"
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                  <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'invoiceNumber'"
                                             [items]="invoiceNumberList"
                                             placeholder="Search"
                                             class="custom-select-grower"
                                             [multiple]="true"
                                             [hideSelected]="true"
                                             [(ngModel)]="productFilters.invoiceNumberList"
                                             [virtualScroll]="true"
                                             bindLabel="value"
                                             bindValue="value"
                                             [closeOnSelect]="true"
                                             [searchFn]="filterSearchFn"
                                             (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                      <div class="dropdown-template">
                                        <div class="row">
                                          <div class="col-md-8">
                                            <p class="name">
                                              {{item.value}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                      <div class="ng-option disabled">
                                        No data found for "{{searchTerm}}"
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                  <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'lotNumber'"
                                             [items]="lotNumberList"
                                             placeholder="Search"
                                             [multiple]="true"
                                             [hideSelected]="true"
                                             class="custom-select-grower"
                                             [(ngModel)]="productFilters.lotNumberList"
                                             [virtualScroll]="true"
                                             bindLabel="value"
                                             bindValue="value"
                                             [closeOnSelect]="true"
                                             [searchFn]="filterSearchFn"
                                             (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                      <div class="dropdown-template">
                                        <div class="row">
                                          <div class="col-md-8">
                                            <p class="name">
                                              {{item.value}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                      <div class="ng-option disabled">
                                        No data found for "{{searchTerm}}"
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                  <ng-select #statusSearch name="ddlStatusSearch" *ngIf="productSearchFilter === 'status'"
                                             [items]="statusList"
                                             placeholder="Search"
                                             [multiple]="true"
                                             [hideSelected]="true"
                                             class="custom-select-grower"
                                             [(ngModel)]="productFilters.status"
                                             [virtualScroll]="true"
                                             bindLabel="value"
                                             bindValue="value"
                                             [closeOnSelect]="true"
                                             [searchFn]="filterSearchFn"
                                             (change)="keepFilter()">
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                      <div class="dropdown-template">
                                        <div class="row">
                                          <div class="col-md-8">
                                            <p class="name">
                                              {{item.value}}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </ng-template>
                                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                      <div class="ng-option disabled">
                                        No data found for "{{searchTerm}}"
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row chips-sec" *ngIf="(!editToolKit || checkBoxCount<=0 || isSearchClicked) && filterValueList != ''">
                            <div class="col-sm-9 col-md-10 selected-chip">
                              <div>
                                <mat-chip-set>
                                  <mat-chip selected *ngFor="let filterValue of filterValueList">
                                    {{filterValue}}
                                    <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                                      <i class="fas fa-times text-right"></i>
                                    </a>
                                  </mat-chip>
                                </mat-chip-set>
                              </div>
                            </div>
                            <div class="col-sm-3 col-md-2 text-right">

                              <a href="Javascript:void(0);" *ngIf="filterValueList.length > 0" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                            </div>
                          </div>
                        </div>

                        <div class="product-tools-tab" *ngIf="showTabs && (!isSearchClicked && editToolKit)">
                          <div class="tab-bar">
                            <ul>
                              <li *ngIf="((isValidLineStatus && !reviewRequestMode) || (requestStatus == 'IN EDIT' && !reviewRequestMode))" (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Products" [matTooltipPosition]="'above'">
                                <i class="icon-ico-trash"></i>
                              </li>
                            </ul>
                          </div>
                          <div class="tab-content">
                            <div *ngIf="tabNode==='delete'" class="delete-product">
                              <div class="tab-content-heading">
                                For: {{selectedAccountName}}
                              </div>
                              <div class="tab-content-detail">
                                <p>Are you sure you want to delete <span> {{checkBoxCount}} </span> selected Items(s)?</p>
                                <div class="btn-area">
                                  <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',true)">Yes</button>
                                  <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',false)">No</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-3 text-right">
                        <div class="row">
                          <div class="col-md-2 text-left padding-l0">
                            <ul class="padding-t10">
                              <li *ngIf="checkBoxCount>0 && isSearchClicked" (click)="isSearchClicked=false;clearAllFilter();">
                                <i class="icon-ico-Close" matTooltip="Close" [matTooltipPosition]="'above'"></i>
                              </li>
                            </ul>
                          </div>
                          <div class="col-md-10 text-center">
                            <button id="btnAddProduct" mat-raised-button class="btns" [disabled]="!isAddProductEnable" *ngIf="(!reviewRequestMode && requestStatus!='PENDING')" (click)="addProduct()">Add Product</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 margin-t10">
                      <div class="productTableOuter">
                        <div class="tableContainer prodTableContainer" id="returnRequestView">
                          <table mat-table [dataSource]="productAllDataSource" multiTemplateDataRows class="matTables productTable">
                            <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                              <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
                        </div>
                        <div *ngIf="column=='product'">
                <th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th>
          </div>
          <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Lot Number</th></div>
          <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
          <div *ngIf="column=='units'"><th mat-header-cell *matHeaderCellDef class="units text-center">Eligible Units</th></div>
          <div *ngIf="column=='dumpedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Dumped Units</th></div>
          <div *ngIf="column=='notes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
          <div *ngIf="column=='approverNotes'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Approver Notes</th></div>
          <td mat-cell *matCellDef="let element">

            <div *ngIf="column=='checkbox'">
              <div *ngIf="requestStatus!='DRAFT' && requestStatus!='IN EDIT'" [ngClass]="{ 'lineitem-error': element.lineStatus =='ERROR', 'lineitem-pending': element.lineStatus =='PENDING', 'lineitem-approved': element.lineStatus =='APPROVED' || element.lineStatus =='PLANNED' || element.lineStatus =='SHIPPED' || element.lineStatus =='SUBMITTED' || element.lineStatus =='INVOICED','lineitem-rejected':element.lineStatus =='REJECTED' || element.lineStatus =='CANCELLED' }" class="lineitem-symbols"></div>
              <div *ngIf="requestStatus == 'IN EDIT'" [ngClass]="{ 'lineitem-approved': element.lineStatus =='APPROVED', 'lineitem-rejected':element.lineStatus =='REJECTED' }" class="lineitem-symbols"></div>
            </div>
            <div *ngIf="column=='checkbox' && !reviewRequestMode && isValidApproveReject(element.productLine , element.marketingBrandId , element)" class="text-center CheckBoxCol"
                 matTooltipClass="updateFont-tooltip" matTooltip="Select Product" [matTooltipPosition]="'above'" matTooltipHideDelay="2000">

              <mat-checkbox *ngIf="element.lineStatus!='APPROVED' && element.lineStatus!='REJECTED' && !reviewRequestMode" #SingleCheck
                            (change)="enableCheckBoxSingle(SingleCheck._checked); element.isSelected=SingleCheck._checked;"
                            [(ngModel)]="element.isSelected"
                            class="custom-checkbox"></mat-checkbox>
            </div>
            <div *ngIf="column=='product'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED' ) }" class="order-info-outer">
              <div class="order-info">
                <p class="prod-id">{{element.itemVendorName}}</p>
                <p class="prod-name">{{element.itemDescription}}</p>
              </div>
            </div>
            <div *ngIf="column=='lotNumber'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED' ) }" class="measureUnit text-center">
              <p> {{element.lotNumber}} </p>
            </div>
            <div *ngIf="column=='uom'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED' )}" class="measureUnit text-center">
              <p> {{element.uom}} </p>
            </div>
            <div *ngIf="column=='units'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED' )}" class="measureUnit text-center">
              <p *ngIf="element.isManualLine" class="handCursor greyBg" matTooltipClass="updateFont-tooltip" matTooltip="This is a manually added item." [matTooltipPosition]="'above'" matTooltipHideDelay="2000"> N/A </p>
              <p *ngIf="!element.isManualLine"> {{element.eligibleUnit}} </p>
            </div>
            <div *ngIf="column=='dumpedUnits'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED')}" class="quantityBlock text-center">
              <div>
                <!--reviewRequestMode:{{reviewRequestMode}} - requestStatus:{{requestStatus}} - lineStatus:{{element.lineStatus}}-->
                <button *ngIf="!((reviewRequestMode && requestStatus!='PENDING') || ((element.lineStatus =='APPROVED' || element.lineStatus =='REJECTED') && requestStatus=='IN EDIT') || (requestStatus=='PENDING'))" [disabled]="element.isDecreaseQtyDisable" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element)"> - </button>
                <input id="txtDumpedUnit_{{element.itemNumber}}" [readonly]="(reviewRequestMode && requestStatus!='PENDING') || (element.lineStatus =='APPROVED' && requestStatus=='IN EDIT') || (!reviewRequestMode && requestStatus=='PENDING' && element.lineStatus=='PENDING')"
                       [disabled]="element.isDecreaseQtyDisable || element.isIncreaseQtyDisable" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)"
                       [(ngModel)]="element.returnQuantity" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" />
                <button *ngIf="!((reviewRequestMode && requestStatus!='PENDING') || ((element.lineStatus =='APPROVED' || element.lineStatus =='REJECTED') && requestStatus=='IN EDIT') || (requestStatus=='PENDING'))" [disabled]="element.isIncreaseQtyDisable" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element)"> + </button>
              </div>
            </div>

            <div *ngIf="column=='seeds'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED')}" class="measureUnit text-center">
              <p> {{element.seedPerPound}} </p>
            </div>
            <div *ngIf="column=='notes'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED')}" class="measureUnit text-center">
              <textarea id="txtRequestorNotes_{{element.itemNumber}}" [readonly]="reviewRequestMode || (element.lineStatus =='APPROVED' && requestStatus=='IN EDIT')" type="text" class="notesTxt" [(ngModel)]="element.requestorNotes" maxlength="250" (input)="hasNotesChanged(element.requestorNotes);"></textarea>
            </div>
            <div *ngIf="column=='approverNotes'" [ngClass]="{ 'disabledrow': (element.lineStatus =='REJECTED' ) }" class="measureUnit text-center">
              <textarea id="txtapproverNotes_{{element.itemNumber}}" [readonly]="reviewRequestMode || (element.lineStatus =='APPROVED' && requestStatus=='IN EDIT')" type="text" class="notesTxt" [(ngModel)]="element.approverNotes" maxlength="250" (input)="hasNotesChanged(element.approverNotes)" required></textarea>
            </div>
          </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
              <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}">
                <div class="row">
                  <div class="col-md-9">
                    <ol class="error-list">
                      <li *ngFor="let err of element.lineErrors.errors">
                        {{err.error}}
                    </ol>
                  </div>
                  <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                    <span>
                      Revert to Previous.
                      <i class="icon-ico-Reply"></i>
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"
              matTooltip="Approved line can't be edited, product could be added. Cancel without saving." [matTooltipPosition]="'above'" matTooltipClass="updateFont-tooltip" matTooltipHideDelay="2000" [matTooltipDisabled]="element.lineStatus !='APPROVED'"
              class="example-element-row" [ngClass]="{'disabledrow':((element.lineStatus =='REJECTED' || element.lineStatus =='APPROVED')  && !element.editable)}"
              [class.example-expanded-row]="expandedElement === element"
              (click)="expandedElement = expandedElement === element ? null : element"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
              </mat-tab>

<mat-tab>
  <ng-template mat-tab-label>
    <div class="tab-head">
      <h4>
        Scale Tickets
      </h4>
      <p>
        Add / Manage Scale Tickets for your return
      </p>
    </div>
  </ng-template>
  <div class="addProdContent">
    <div class="row listing-action-items grower-page scaleTicketFilterSec" *ngIf="!reviewRequestMode || isScaleTicketEnable">
      <div class="col-sm-9 col-md-8">
        <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                      *ngIf="scaleTicketDataSource.data.length>0 && isScaleTicketEnable"
                      [checked]="selectedTicketCount > 0 && selectedTicketCount === scaleTicketDataSource.data.length"
                      [style.display]="disableScaleCheckbox? 'none' : 'block'"
                      [indeterminate]="scaleTicketDataSource > 0 && selectedTicketCount > 0 && selectedTicketCount < scaleTicketDataSource.length"
                      (change)="EnableAllEditToolKit(!allTicketChecked)"
                      title="Select All Scale Tickets"></mat-checkbox>
        <div class="product-tools-tab" *ngIf="showScaleTabs">
          <div class="tab-bar">
            <ul>
              <li *ngIf="showScaleDelete && isScaleTicketEnable" (click)="showTab('deleteTicket')" [ngClass]="{'active': tabNode==='deleteTicket'}" class="seperator" matTooltip="Delete Scale Tickets" [matTooltipPosition]="'above'" matTooltipClass="updateFont-tooltip" matTooltipHideDelay="2000">
                <i class="icon-ico-trash"></i>
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div *ngIf="tabNode==='deleteTicket'" class="delete-product">
              <div class="tab-content-heading">
                For: {{selectedAccountName}}
              </div>
              <div class="tab-content-detail">
                <p>Are you sure you want to delete <span> {{selectedTicketCount}} </span> selected Tickets(s)?</p>
                <div class="btn-area">
                  <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('deleteTicket',true)">Yes</button>
                  <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('deleteTicket',false)">No</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3 col-md-4 text-right">
        <input hidden
               type="file"
               #uploader
               (change)="uploadTicket($event)" multiple
               accept=".xls,.xlsx,.png,.tiff,.jpg,.jpeg,.doc,.docx,.ppt,.pptx,.txt,.pdf" />
        <button mat-raised-button class="btns" matTooltip="{{scaleTicketTooltip}}" [matTooltipPosition]="'above'" [disabled]="!isScaleTicketEnable" *ngIf="(!reviewRequestMode || isScaleTicketEnable)" (click)="uploader.click()">Upload Scale Ticket</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 margin-t10">
        <div class="productTableOuter">
          <div class="tableContainer scaleTableContainer">
            <table mat-table [dataSource]="scaleTicketDataSource" multiTemplateDataRows class="matTables productTable">
              <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedScaleColumns">
                <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
          </div>
          <div *ngIf="column=='scalesTicketName'">
  <th mat-header-cell *matHeaderCellDef class="scaleTicketName">Scale Ticket Name</th></div>
  <div *ngIf="column=='uploaded'"><th mat-header-cell *matHeaderCellDef class="uploadDate text-center">Upload Date</th></div>
  <div *ngIf="column=='fileType'"><th mat-header-cell *matHeaderCellDef class="fieType text-center">File Type</th></div>
  <div *ngIf="column=='viewFile'"><th mat-header-cell *matHeaderCellDef class="viewFile text-center">View File</th></div>
  <td mat-cell *matCellDef="let element">
    <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol" matTooltip="Select Scale Ticket" [matTooltipPosition]="'above'" matTooltipClass="updateFont-tooltip" matTooltipHideDelay="2000">
      <mat-checkbox *ngIf="!reviewRequestMode" #SingleScaleCheck
                    (change)="enableTicketCheckBoxSingle(SingleScaleCheck._checked); element.isSelected=SingleScaleCheck._checked;"
                    [(ngModel)]="element.isSelected"
                    class="custom-checkbox"></mat-checkbox>
    </div>
    <div *ngIf="column=='scalesTicketName'" class="order-info-outer">
      <div class="order-info">
        <p class="prod-name largeTableTxt"> {{element.fileDisplayName}}</p>
      </div>
    </div>
    <div *ngIf="column=='uploaded'" class="measureUnit text-center">
      <p class="largeTableTxt"> {{element.uploadedAt}}</p>
    </div>
    <div *ngIf="column=='fileType'" class="measureUnit text-center">
      <p class="largeTableTxt"> {{element.fileType}}</p>
    </div>
    <div *ngIf="column=='viewFile'" class="measureUnit text-center">
      <span class="view-file" [ngClass]="{'disabledViewFile': reviewRequestMode}" matTooltip="View File" [matTooltipPosition]="'above'" matTooltipClass="updateFont-tooltip" matTooltipHideDelay="2000">
        <img id="viewFile" class="" src="../assets/icon/svg/view.svg" alt="" (click)="downloadTicket(element)" />
      </span>
    </div>
  </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedScaleColumns;sticky:true;"></tr>
  <tr mat-row *matRowDef="let element; columns: displayedScaleColumns;"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element"></tr>
  </table>
  </div>
  </div>
  </div>
  </div>
  </div>
</mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>

<!--Error section on table-->
<div class="common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
  <div class="row">
    <div class="col-md-2 padding-r0 errCountOuter">
      <span class="errorCounting">
        {{currentErrorRow}} of {{errorMsgs.length}}
      </span>
    </div>
    <div class="col-md-6 padding-l0 ">
      <ul class="errorMsg">
        <li *ngFor="let err of errorMsgs[index].errors">
          <p> {{err.error}}</p>
        </li>
      </ul>
    </div>

    <div class="col-md-4 button-sec text-right">
      <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
      <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()">Next Error</button>
    </div>
  </div>
</div>

<div class="SeedFulfillBtnSec">
  <div class="row padding-l20">

    <div class="col-md-10">
      <div class="product-tools-tab display-ib" *ngIf="showTabs && (!isSearchClicked && editToolKit)">
        <div class="tab-bar">
          <button *ngIf="isApprovalAccess && !reviewRequestMode && isEditMode && requestStatus!='DRAFT' && requestStatus!='IN EDIT' " id="btnApprove" mat-raised-button class="btns w140" color="primary" (click)="showTab('approve')">Approve</button>
          <button *ngIf="isApprovalAccess && !reviewRequestMode && isEditMode && requestStatus!='DRAFT' && requestStatus!='IN EDIT' " id="btnReject" mat-raised-button class="btns w140" color="primary" (click)="showTab('reject')" [style.display]="'inline-block'">Reject</button>
        </div>
      </div>
      <button mat-raised-button class="btns" *ngIf="!reviewRequestMode && showSubmitToJde && requestStatus!='IN EDIT' && isApprovalAccess" [disabled]="isDisableSubmitForCreditBtn()" (click)="submitJDERequest()" [style.display]="'inline-block' " id="btnSubmitForCredit">Submit For Credit</button>
      <button mat-raised-button class="btns w140" color="primary" *ngIf="(!reviewRequestMode && showSubmitToJde && requestStatus!='IN EDIT' && isApprovalAccess) || (!isEditMode && !showSubmitReturn && isScaleTicketEnable)" [disabled]="isNotValid || productAllDataSource.filteredData.length <= 0" (click)="saveRequest()" [style.display]="'inline-block'" id="btnSaveRequest">Save</button>
      <button mat-raised-button class="btns w140" color="primary" *ngIf="!reviewRequestMode && showSubmitToJde && isShowEditButton()" (click)="OnEditClick('IN EDIT')" [style.display]="'inline-block'">Edit Request</button>

      <button mat-raised-button class="btns" *ngIf="!reviewRequestMode && requestStatus=='IN EDIT'" [disabled]="isNotValid || productAllDataSource.filteredData.length <= 0" (click)="placeRequest(true)" [style.display]="'inline-block' " id="btnSaveAndSubmit">Save changes and submit request</button>
      <button mat-raised-button class="btns" color="primary" *ngIf="!reviewRequestMode && requestStatus=='IN EDIT'" [disabled]="isNotValid" (click)="placeRequest(false)" [style.display]="'inline-block'" id="btnSaveAndDiscard">Discard changes and submit request</button>

      <button mat-raised-button class="btns" *ngIf="!reviewRequestMode && showSubmitReturn && !isAutoApprove" [disabled]="(!isPlaceOrderEnable)" (click)="placeRequest(true)" [style.display]="'inline-block' " id="btnSubmitRequest">Submit for Approval</button>

      <!--This button enables when Auto Approve is enable--> 
      <button mat-raised-button class="btns" *ngIf="!reviewRequestMode && showSubmitReturn  && isAutoApprove" [disabled]="(!isPlaceOrderEnable)" (click)="submitForCreditAutoApproval()" [style.display]="'inline-block' " id="btnSubmitForCredit">Submit For Credit</button>
      <button mat-raised-button class="btns" color="primary" *ngIf="!reviewRequestMode && showSubmitReturn" (click)="saveDraft()" [disabled]="!isSaveOrderDraftEnable" [style.display]="'inline-block'" id="btnSaveDraft">Save Draft</button>
    </div>
    <div class="text-right" style="position: absolute; right: 40px; margin-top: 5px;">
      <span class="count">Returnable Products <span>{{selectedCount}}</span></span>
    </div>
  </div>
</div>
    </div>
  </div>
</div>
